import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class QsignerService {
  readonly URL_API = '/api/qapp/qsigner/';
  readonly URL_API_QIS = '/api/qis/';
  private protocol = 'https://';

  constructor(private http: HttpClient) {}

  // GET Signs.
  public getSigns(url: string, signs: any): Observable<Object> {
    return this.http.post(this.protocol + url + this.URL_API + 'signs/', signs);
  }
  // POST Customer.
  public postSignature(url: string, signs: any): Observable<Object> {
    return this.http.post(this.protocol + url + this.URL_API + 'signatures/', signs);
  }
  // GET API.
  public getApi(url: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'getApi');
  }
  // GET Server by dms code.
  public getServersByDmsCode(url: string, id: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'bydmscode/' + id);
  }
}
